import { CONTROL_PLANE_UNREACHABLE_REASON } from 'k8s/components/kaapi/machines/machineHealth'

// Title for the cluster-details unhealthy-nodes banner.
// Lost connectivity and provisioning failures are distinct causes, so a set
// containing both has to report each count separately - deriving the title
// from the first (worst-ranked) machine alone labelled every unhealthy node
// with that one machine's cause.
export const getUnhealthyMachinesBannerTitle = (unhealthyMachines = []): string => {
  if (!unhealthyMachines.length) return ''

  const connectionLost = unhealthyMachines.filter(
    (m) => m?.machineHealth?.reason === CONTROL_PLANE_UNREACHABLE_REASON,
  )
  const provisionFailing = unhealthyMachines.filter(
    (m) => m?.machineHealth?.reason !== CONTROL_PLANE_UNREACHABLE_REASON,
  )

  const connectionLostTitle = `${connectionLost.length} node${
    connectionLost.length > 1 ? 's have' : ' has'
  } lost connectivity`
  // Only qualify as "control plane" when every provisioning failure is a
  // master - the connection-lost nodes are reported separately and must not
  // influence this.
  const provisionFailingTitle = `${provisionFailing.length}${
    provisionFailing.every((m) => m?.nodeType === 'Master') ? ' control plane' : ''
  } node${provisionFailing.length > 1 ? 's are' : ' is'} failing to provision`

  if (!provisionFailing.length) return connectionLostTitle
  if (!connectionLost.length) return provisionFailingTitle
  return `${connectionLostTitle}, ${provisionFailingTitle}`
}
